export const CONTACT_TOPIC_MAP = Object.freeze({
  product: 'general',
  account: 'account',
  assignment: 'assessment_creation',
  lesson: 'general',
  billing: 'billing',
  team: 'general',
  privacy: 'general',
  partnership: 'general',
  feedback: 'general',
  other: 'general',
});

export const CONTACT_ENDPOINT = '/api/public/index.php?route=v1/support/contact';

export async function submitContactRequest(fetchImpl, values) {
  const response = await fetchImpl(CONTACT_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      name: values.name.trim(),
      email: values.email.trim(),
      topic: CONTACT_TOPIC_MAP[values.category],
      message: values.message.trim() + (values.phone.trim() ? `\n\nPhone or WhatsApp: ${values.phone.trim()}` : ''),
      source: 'rankerd_marketing_contact',
      website_url: values.website_url || '',
    }),
  });
  const body = await response.json().catch(() => ({}));
  return { ok: response.ok && body.success === true, response, body };
}
